import { useCallback, useState } from "react";
import { toast } from "react-hot-toast";
import api from "../../../common/api";
import Spinner from "../../../common/Spinner/Spinner";
import Button from "../../../layouts/Button";
import HFlex from "../../../layouts/HFlex";
import Text from "../../../layouts/Text";
import TextArea from "../../../layouts/TextareaV2";
import VFlex from "../../../layouts/VFlex";
import ConfirmPopup from "../../../popup/ConfirmPopup";
import { PopupAlign, PopupKind } from "../../../popup/Popup";
import { usePartner } from "../../../providers/partner";
import { pushPopup } from "../../../providers/popups";
import { useAmplitudeTrack } from "../../../common/useAmplitudeTrack";

function ReservationInfo({ popPopup }: { popPopup: () => void }) {
  const { trackSaveResInfo } = useAmplitudeTrack();
  const { partner, fetchPartner } = usePartner();
  const [text, setText] = useState<string>(partner.notice);
  const [sending, setSending] = useState<boolean>(false);
  const isChanged = useCallback(() => {
    return text !== partner.notice;
  }, [text, partner]);
  return (
    <VFlex f-1 a-st p-24-t rel ovf-h>
      <Text t-20-700-s9 m-32-rl>
        예약 시 안내사항
      </Text>
      {sending ? (
        <VFlex f-1 c-c>
          <Spinner />
        </VFlex>
      ) : (
        <VFlex f-1 g-8>
          <Text t-14-500-s4 m-24-t m-32-rl>
            예약 시 안내사항 입력
          </Text>
          <VFlex m-32-rl>
            <TextArea
              value={text ?? ""}
              onChangeValue={(v) => {
                if (v?.length || 0 <= 800) setText(v as string);
              }}
              placeholder={"예약 시 안내사항을 작성해주세요."}
              height={360}
              maxLength={800}
            />
          </VFlex>
          <Text
            t-14-700-s9
            m-16-t
            m-32-rl
            style={{ color: "#3EBA86", textDecorationLine: "underline" }}
            clickable
            onClick={() =>
              window.open(
                "https://pawdly.notion.site/cf24248a1917403784916adaf6e34ad7",
                "_blank"
              )
            }
          >
            자세히 알아보기
          </Text>
          <VFlex f-1 />
        </VFlex>
      )}
      <HFlex g-8 m-24-t p-32-rl height={86} bd-t-t3 a-c>
        <VFlex f-1 />
        <Button
          type="cancel"
          onClick={() => {
            isChanged()
              ? pushPopup({
                  kind: PopupKind.Popup,
                  align: PopupAlign.TopCenter,
                  element: ConfirmPopup,
                  props: {
                    title: "변경사항을 저장하지 않고 닫을까요?",
                    onConfirm: () => {
                      popPopup();
                    },
                  },
                })
              : popPopup();
          }}
          caption="취소"
        />
        <Button
          type="confirm"
          enabled={isChanged()}
          onClick={async () => {
            if (!isChanged()) {
              return;
            }
            setSending(true);
            await api.put(`/rest/group/${partner.id}/notify`, {
              message: text,
            });
            await fetchPartner();
            toast.success("저장되었습니다.");
            setSending(false);
            trackSaveResInfo(partner.title);
          }}
          caption="저장"
        />
      </HFlex>
    </VFlex>
  );
}

export default ReservationInfo;
